module.exports = __webpack_public_path__ + "media/images/icon/icons8-Feedback-d180b2f4af4bfd7081bcea8f929223d0.png";